<template>
  <div>
    <div ref="graphContainer" class="w-full h-full">
      <div :id="`container-${chart.Id}`"></div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import * as d3 from "d3";

// #region Props, Emits
const props = defineProps({
  chart: {
    type: Object,
    required: true,
  },
});
// #endregion

// #region Params, Ref, Reactives, Computed
const graphContainer = ref(null);
// #endregion

// #region Functions
function loadGraph(id, width, height) {
  // graphContainer width and height
  const margin = 40;

  // Create the container.
  const container = d3.select(id);

  // Create the SVG element.
  const svg = container
    .append("svg")
    .attr("width", width)
    .attr("height", height);

  // Create a pie chart
  const pie = d3.pie().value((d) => d.value);

  // Create an arc generator.
  const arc = d3
    .arc()
    .innerRadius(0)
    .outerRadius(Math.min(width, height) / 2 - 1);

  // Create a color scale.
  const color = d3.scaleOrdinal(d3.schemeCategory10);

  // Create a group for the pie chart.
  const g = svg
    .append("g")
    .attr("transform", `translate(${width / 2},${height / 2}) scale(0.9)`);

  let data = [];
  const valores = props.chart.propiedades.tarta;

  valores.forEach((valor) => {
    data.push({
      label: valor.nombre,
      value: valor.valor,
    });
  });

  // Create the pie chart.
  g.selectAll("path")
    .data(pie(data))
    .join("path")
    .attr("fill", (d, i) => {
      if (valores[i].color) {
        return valores[i].color;
      } else {
        return color(i);
      }
    })
    .attr("d", arc)
    .append("title")
    .text((d) => `${d.data.label}: ${d.data.value}`);

  // When hover over the pie chart, show the label and value
  // g.selectAll("path")
  //   .on("mouseover", function (d, i) {
  //     const g = d3.select(this);
  //     const rect = g.node().getBoundingClientRect();
  //     const x = rect.x + rect.width / 2;
  //     const y = rect.y + rect.height / 2;

  //     svg
  //       .append("text")
  //       .attr("id", "tooltip")
  //       .attr("x", x)
  //       .attr("y", y)
  //       .attr("text-anchor", "middle")
  //       .attr("font-size", "1.5em")
  //       .text(`${i.data.label}: ${i.data.value}`);
  //   })
  //   .on("mouseout", function () {
  //     svg.select("#tooltip").remove();
  //   });

  // Create a legend.
  const legend = svg
    .append("g")
    .attr("transform", `translate(${width},0)`)
    .attr("text-anchor", "end")
    .selectAll("g")
    .data(data)
    .join("g")
    .attr("transform", (d, i) => `translate(0, ${i * 25})`);

  legend
    .append("rect")
    .attr("x", margin * -1)
    .attr("y", margin)
    .attr("width", 19)
    .attr("height", 19)
    .attr("fill", (d, i) => {
      if (valores[i].color) {
        return valores[i].color;
      } else {
        return color(i);
      }
    });

  legend
    .append("text")
    .attr("x", (margin + 10) * -1)
    .attr("y", margin + 10)
    .attr("dy", "0.3em")
    .text((d) => d.label);
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
defineExpose({
  graphContainer,
  loadGraph,
});
// #endregion
</script>
